import { useTranslation } from "react-i18next";
import React, {
  Fragment,
  memo,
  useCallback,
  useEffect,
  useMemo, useRef,
  useState,
} from 'react';
import * as _ from "lodash";
import {
  Checkbox,
  FormLabel,
  IconButton,
  List,
  ListItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  MenuItem,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import config from "../../app/config";
import AgyleButton from "../../components/ui/buttons/agyleButton";
import { AgyleNamedIcon } from "../../components/icons/agyle";
import { isChild, admitBase } from "./admitPatient";
import moment from "moment";
import Divider from "@mui/material/Divider";
import useOpenState from "../../hooks/useOpenState";
import DialogContent from "@mui/material/DialogContent";
import InformationBox from "../../components/other/informationBox";
import clsx from "clsx";
import Chip from "@mui/material/Chip";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import {
  OverseasVisitorChargingCategory,
  Relationship,
} from "../../controls/agyle/dictionaries";
import useDict from "../../hooks/useDict";
import { useStylesECDS } from "../ward/forms/ecds/ecdsStyle";
import { useDispatch, useSelector } from "react-redux";
import { user } from "../../store/reducers/user";
import Formatter from "../../util/formatter";
import uuidv4 from "uuid/v4";
import DeleteIcon from "@mui/icons-material/Delete";
import MessageBox from "../../util/messageBox";
import AgyleBlockSwitch from "../../components/ui/switch/agyleBlockSwitch";
import AgyleDatePicker from "../../components/ui/fields/agyleDatePicker";
import AgyleTextField from "../../components/ui/fields/agyleTextField";
import AgyleDictionaryField from "../../components/ui/selector/agyleDictionaryField";
import { setSnackbar } from "../../store/reducers/globals";
import DialogTitle from "@mui/material/DialogTitle";
import {AccommodationStatus} from '../../controls/agyle/ecds';
import ControlGP from '../../controls/agyle/gp/ControlGP';
import ControlSurgery from '../../controls/agyle/gp/ControlSurgery';
import AddressFinderControl from '../../components/postCode/addressFinderControl';
import AgyleAccordion from '../../components/ui/accordion/agyleAccordion';
import API from '../../app/api';
import {useDebounce} from 'use-debounce';
import {getEcdsVersion} from '../../store/reducers/dicts';

const useStyles = makeStyles((theme) => ({
  body: {
    width: "90%",
    margin: "30px 5% 5% 5%",
  },
  content: {
    padding: 20,
    margin: 20,
  },
  bodyTitle: {
    fontSize: 18,
  },
  background: {
    backgroundColor: theme.palette.background.default,
  },
  backDrop: {
    backdropFilter: "blur(3px)",
    backgroundColor: "rgba(0,0,30,0.4)",
  },
  dialogTitle: {
    textAlign: "center",
    padding: "10px",
  },
  dialogContent: {
    width: "100%",
  },
  title: {
    textAlign: "center",
    width: "100%",
  },
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  search: {
    borderRadius: theme.shape.borderRadius,
    "&:hover": {
      // backgroundColor: theme.palette.background.,
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    width: "60% !important",
    left: "20%",
    position: "fixed",
    marginTop: "-64px",
    fontSize: 20,
    textAlign: "center",
  },

  searchInput: {
    padding: "20px 0 20px 0",

    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      paddingLeft: " 40px !important",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    //height: '100%',
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.mainColor,
    marginLeft: 0,
    marginTop: 8,
  },
  fullName: {
    display: "inline-block",
    marginLeft: 10,
    fontWeight: 300,
  },
  familyName: {
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: 5,
  },
  vvip: {
    color: "#e46060",
    border: "1px solid #e46060",
    padding: "3px",
    fontSize: "10px",
    marginRight: "6px",
    borderRadius: "16px",
    verticalAlign: "middle",
    display: "inline-block",
    height: "20px",
  },
  patientsTable: {},
  searchButtons: {
    textAlign: "center",
  },
  tableHeader: {
    backgroundColor: theme.palette.mode === "light" ? "#e2e2e2" : "#363636",
    padding: "5px",
    marginBottom: "7px",
    color: "gray",
    fontSize: 12,
  },
  tableRecord: {
    padding: "8px",
    marginBottom: "7px",
    backgroundColor: theme.palette.mode === "light" ? "#cacaca" : "#434343",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.default.main,
    },
  },
  pagination: {
    width: "fit-content",
    margin: "auto",
  },
  fullNameHeader: {
    marginLeft: "10px",
  },
  sortedHeader: {
    cursor: "pointer",
  },
  buttonSelector: {
    borderRadius: 50,
    backgroundColor: theme.palette.grey["300"],
    color: "rgba(0, 0, 0, 0.87)",
    margin: "0 5px",
    fontSize: 10,
  },
  headerText: {
    float: "left",
    marginTop: 4,
  },
  formControl: {
    width: "100%",
  },
  next: {
    width: "50%",
    margin: "auto",
  },
  error: {
    color: "#f44336",
  },
  patientHeaderItem: {
    fontSize: 14,
    verticalAlign: "top",
    lineHeight: "24px",
    display: "inline-block",
    margin: "0 5px",
    backgroundColor: theme.palette.background.paper,
    padding: "2px 7px",
    borderRadius: 5,
    "& .label": {
      marginRight: 5,
      fontSize: "90%",
    },
    "& .value": {
      fontWeight: "bold",
    },
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    width: "100%",
    marginBottom: "15px",
    paddingLeft: "15px",
  },
  currentPatient: {
    fontSize: "large",
    fontWeight: "bold",
    "&.center": {
      textAlign: "center",
    },
  },
  unknownPatientDate: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    maxWidth: "230px",
  },
  phoneNumberContainer: {
    background: theme.palette.background.default,
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexGrow: 1,
  },
  bannerContainer: {
    width: "100%",
    marginLeft: 15,
  },
  errorBorder: {
    border: "1px solid red",
    boxShadow: "0 0 5px red",
  },
  errorBackground: {
    backgroundColor: theme.palette.error.main,
  },
  buttonNFA: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
    margin: "5px 0"
  },
}));

const ChildAccordion = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { admit, handleChangeInput, setAdmit, checkDisabled, patientIsSelected, disabled, isAddOnlyPatient, mergeToNewCreatedPatient } = props;

  const initEscort = {
    name: "",
    phone: "",
    relationship: "",
    parentalResponsibility: false,
    attendedWithChild: false,
    contact: "",
  };
  const [escortForm, setEscortForm] = useState(initEscort);

  const informationMessage =
    "Please add who does have parental/legal responsibility for the patient and what are their contact details, and who attended with a child";

  const handleChangeEscort = (e) => {
    const { name, value } = e.target;

    setEscortForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAddEscort = () => {
    let escortArr;

    if (admit.escortArray.length === 0) {
      escortArr = [escortForm];
    } else {
      escortArr = [...admit.escortArray, escortForm];
    }
    setAdmit((prevState) => ({
      ...prevState,
      escortArray: escortArr,
    }));
    setEscortForm(initEscort);
  };

  const handleRemoveEscort = (index) => {
    const newEscortArray = admit.escortArray.filter((escort, i) => i !== index);

    setAdmit((prevState) => ({
      ...prevState,
      escortArray: newEscortArray,
    }));
  };

  return (
    <AgyleAccordion expanded label={t('Details')}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <AgyleTextField
              size={"large"}
              fullWidth
              multiline
              disabled={checkDisabled()}
              variant="outlined"
              label={"School name"}
              className={classes.formControl}
              value={admit.schoolName}
              error={!admit.schoolName}
              name={"schoolName"}
              onChange={handleChangeInput}
              InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <AgyleTextField
              size={"large"}
              fullWidth
              disabled={checkDisabled()}
              variant="outlined"
              label={"School postal code"}
              className={classes.formControl}
              value={admit.schoolPostalCode}
              name={"schoolPostalCode"}
              onChange={handleChangeInput}
              InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <AgyleTextField
              size={"large"}
              fullWidth
              multiline
              disabled={checkDisabled()}
              variant="outlined"
              label={"School address"}
              className={classes.formControl}
              value={admit.schoolAddress}
              name={"schoolAddress"}
              onChange={handleChangeInput}
              InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <AgyleTextField
              multiline
              disabled={checkDisabled()}
              variant="outlined"
              size="large"
              label={"School contact"}
              className={classes.formControl}
              value={admit.schoolContact}
              fullWidth
              name={"schoolContact"}
              onChange={handleChangeInput}
              InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
      {(!isAddOnlyPatient && patientIsSelected && !mergeToNewCreatedPatient) && <>
        <Grid item xs={12} sx={{ my: 2 }}>
          <Divider textAlign="left">Household</Divider>
        </Grid>

        <AdmitHousehold
            admit={admit}
            setAdmit={setAdmit}
            checkDisabled={checkDisabled}
            disabled={disabled}
        />
      </>
      }
    </AgyleAccordion>
  );
};

const AdultAccordion = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { admit, handleChangeInput, isChild, setAdmit, checkDisabled } = props;
  return (
      <AgyleAccordion expanded label={t('Other patient information')}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <AgyleTextField
              size={"large"}
              multiline
              disabled={checkDisabled()}
              variant="outlined"
              label={"Employer name"}
              className={classes.formControl}
              value={admit.employerName}
              fullWidth
              name={"employerName"}
              onChange={handleChangeInput}
              error={!isChild() && !admit.employerName}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AgyleTextField
              size={"large"}
              disabled={checkDisabled()}
              variant="outlined"
              label={"Employer postal code"}
              className={classes.formControl}
              value={admit.employerPostalCode}
              fullWidth
              name={"employerPostalCode"}
              onChange={handleChangeInput}
              error={!isChild() && !admit.employerPostalCode}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AgyleTextField
              size={"large"}
              multiline
              disabled={checkDisabled()}
              variant="outlined"
              label={"Employer address"}
              className={classes.formControl}
              name={"employerAddress"}
              value={admit.employerAddress}
              fullWidth
              onChange={handleChangeInput}
              error={!isChild() && !admit.schoolAddress}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </AgyleAccordion>
  );
};

const AdmitHousehold = ({ admit, setAdmit, checkDisabled, disabled}) => {
  const classes = useStylesECDS();
  const { t } = useTranslation();

  const userObject = useSelector(user);
  const timestamp = moment().toISOString();
  const tester = Formatter.formatUserFullName(userObject);
  const [householdData, setHouseholdData] = useState([]);
  const updated = useRef(false);

  useEffect(() => {
    if (!updated.current && !_.isEmpty(admit?.household)) {
      setHouseholdData(admit?.household);
      updated.current = true;
    }
  }, [admit?.household]);

  const addNewHousehold = () => {
    const emptyObj = {
      id: uuidv4() + "",
      householdInformation: "",
      householdPeople: [],
      date: timestamp,
      by: tester,
      login: userObject?.userName,
    };

    setHouseholdData((prevState) => [...prevState, emptyObj]);
  };

  useEffect(() => {
    setAdmit((prevState) => ({
      ...prevState,
      household: householdData,
    }));
  }, [householdData]);

  const deleteHousehold = (id) => {
    setHouseholdData((prevState) => prevState.filter((item) => item.id !== id));
  };

  const renderNewHousehold = (description) => {
    return (
      <Fragment>
        <Paper className={classes.paper} elevation={3}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item xs={8}>
              {description && (
                <h3 className={classes.description}>
                  {t(
                    "No household information was provided, please add a new household"
                  )}
                </h3>
              )}
            </Grid>
          </Grid>
        </Paper>
      </Fragment>
    );
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      <Grid item xs={12} sx={{ mx: 2 }}>
        <InformationBox type={"info"}>
          {t("Record the following information")}
          <ul>
            <li>
              {t(
                "Please state who else lives in the household with the child?"
              )}
            </li>
            <li>
              {t(
                "Under 18s - Please state Name, Age and relationship to the child."
              )}
            </li>
            <li>
              {t("Over 18s - Please state Name and relationship to the child.")}
            </li>
          </ul>
        </InformationBox>
      </Grid>
      <Grid item xs={12}>
        {householdData &&
          householdData.length === 0 &&
          renderNewHousehold(true)}
        {householdData.map((element, index) => {
          return (
            <div key={element.id + index}>
              <HouseholdComponent
                admit={admit}
                setAdmit={setAdmit}
                data={element}
                id={element.id}
                index={index}
                householdData={householdData}
                setData={setHouseholdData}
                delete={deleteHousehold}
                disabled={disabled}
              />
            </div>
          );
        })}
        {householdData &&
          householdData.length !== 0 &&
          renderNewHousehold(false)}

        <Button
          variant="contained"
          style={{ margin: "10px", width: "auto", float: "right" }}
          disabled={checkDisabled()}
          onClick={addNewHousehold}
        >
          {t("Add New Household")}
        </Button>
      </Grid>
    </Grid>
  );
};

const HouseholdComponent = (props) => {
  const classes = useStylesECDS();
  const { t, i18n } = useTranslation();
  const userObject = useSelector(user);
  const dispatch = useDispatch();

  //  For Delete
  const [deleteItem, setDeleteItem] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogHouseholdOpen, setDialogHouseholdOpen] = useState(false);

  const tester = Formatter.formatUserFullName(userObject);

  // Data form
  const [householdComponent, setHouseholdComponent] = useState(props.data);
  const [form, setForm] = useState({
    parentalResponsibility: false,
    name: "",
    age: "",
    relationship: "",
    contact: "",
  });
  const [error, setError] = useState(false);

  const { disabled } = props;

  useEffect(() => {
    const index = props.index;
    let householdComp = _.cloneDeep(householdComponent);
    const newArray = props.householdData;

    if (props.householdData.length > 0) {
      newArray[index] = householdComp;
      props.setData(newArray);
    }
  }, [householdComponent]);

  const deletePeople = () => {
    let householdComp = _.cloneDeep(householdComponent);
    householdComp.householdPeople = householdComp.householdPeople.filter(
      (v) => v.id !== deleteItem.id
    );
    setHouseholdComponent(householdComp);

    setDeleteItem(null);
    setDialogOpen(false);
  };

  const deleteHousehold = () => {
    props.delete(props.id);
    setDeleteItem(null);
    setDialogHouseholdOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((prevState) => ({ ...prevState, [name]: value }));
  };

  const checkboxHandler = (event, type) => {
    const { name, checked } = event.target;

    setForm((prevState) => ({ ...prevState, [name]: checked }));
  };

  const addToTable = () => {
    const error = form.name !== "" && form.relationship !== "";
    if (!error) {
      setError(true);
    } else {
      const dataForm = {
        ...form,
        id: uuidv4() + "",
        date: moment().toISOString(),
        by: tester,
        login: userObject?.userName,
      };

      if (typeof householdComponent.householdPeople === "undefined") {
        setHouseholdComponent((prevState) => ({
          ...prevState,
          householdPeople: [dataForm],
        }));
      } else {
        setHouseholdComponent((prevState) => ({
          ...prevState,
          householdPeople: [...prevState.householdPeople, dataForm],
        }));
      }
      setForm({
        parentalResponsibility: false,
        name: "",
        age: "",
        relationship: "",
        contact: "",
      });
      setError(false);
    }
  };

  const renderTable = useMemo(() => {
    if (householdComponent && householdComponent.householdPeople) {
      return (
        <Fragment>
          <Grid item xs={12}>
            <TableContainer component={Paper} className={classes.table}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">{t("No")}</TableCell>
                    <TableCell>{t("Person Name")}</TableCell>
                    <TableCell align="center">
                      {t("Parental Responsibility")}
                    </TableCell>
                    <TableCell align="right">{t("Age")}</TableCell>
                    <TableCell align="right">{t("Relationship")}</TableCell>
                    <TableCell align="right">{t("Contact Details")}</TableCell>
                    <TableCell align="center">{t("Delete")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {householdComponent.householdPeople.map((row, index) => (
                    <TableRow
                      key={row.id + index}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={row.parentalResponsibility}
                          disabled={true}
                        />
                      </TableCell>
                      <TableCell align="right">{row.age}</TableCell>
                      <TableCell align="right">{row.relationship}</TableCell>
                      <TableCell align="right">{row.contact}</TableCell>
                      <TableCell align="center">
                        <Button
                          disabled={disabled}
                          onClick={() => {
                            setDeleteItem(row);
                            setDialogOpen(true);
                          }}
                        >
                          <DeleteIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Fragment>
      );
    }
  }, [householdComponent, disabled]);

  const renderHousehold = useMemo(() => {
    return (
      <Fragment>
        <Paper className={classes.paper} elevation={3}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <span style={{ margin: "10px" }}>
              {" "}
              {t("Household ")} {props.index + 1}
              <Button
                disabled={disabled}
                onClick={() => {
                  // setDeleteItem(householdComponent);
                  setDeleteItem(householdComponent);
                  setDialogHouseholdOpen(true);
                }}
              >
                <DeleteIcon />
              </Button>
            </span>
          </Grid>

          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item xs={12} md={5}>
              <AgyleTextField
                size={"large"}
                fullWidth
                name="name"
                label={t("Name")}
                className={classes.input}
                onChange={handleChange}
                value={form.name || ""}
                variant="outlined"
                error={error}
                disabled={disabled}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <AgyleTextField
                size={"large"}
                fullWidth
                name="age"
                label={t("Age")}
                className={classes.input}
                onChange={handleChange}
                value={form.age || ""}
                variant="outlined"
                type={"number"}
                inputProps={{ maxLength: 3 }}
                disabled={disabled}
              />
            </Grid>

            <Grid item xs={12} md={5}>
              <AgyleTextField
                size={"large"}
                fullWidth
                name="relationship"
                label={t("Relationship")}
                className={classes.input}
                onChange={handleChange}
                value={form.relationship || ""}
                variant="outlined"
                error={error}
                disabled={disabled}
              />
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid
                  item
                  xs={12}
                  md={4}
                  style={{ display: "flex", maxHeight: "35px" }}
                  sx={{ mb: 1 }}
                >
                  <FormLabel sx={{ ml: 0.5, mr: 3, mt: 0.5 }}>
                    {t("Parental Responsibility")}
                  </FormLabel>
                  <AgyleBlockSwitch
                      disabled={disabled}
                    onChange={(val) =>
                      setForm({ ...form, parentalResponsibility: val })
                    }
                    value={form.parentalResponsibility || false}
                    style={{ marginRight: 10 }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={8}
                  sx={{
                    pl: {
                      xs: 0,
                      md: 1,
                    },
                  }}
                >
                  <AgyleTextField
                    size={"large"}
                    fullWidth
                    name="contact"
                    label={t("Contact details")}
                    className={classes.input}
                    onChange={handleChange}
                    value={form.contact || ""}
                    variant="outlined"
                    disabled={disabled}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            style={{ marginTop: "10px" }}
          >
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item xs={12}>
                <AgyleTextField
                  size={"large"}
                  fullWidth
                  name="householdInformation"
                  label={t("Household Additional Information")}
                  className={classes.input}
                  disabled={disabled}
                  onChange={(event) =>
                    setHouseholdComponent((prevState) => ({
                      ...prevState,
                      householdInformation: event.target.value,
                    }))
                  }
                  value={householdComponent.householdInformation || ""}
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Button
                variant="contained"
                onClick={addToTable}
                // disabled={props.disableSave || !dispatch(hasPermission(Permissions.AGYLE_CAN_MANAGE_HOUSEHOLD))}>
                disabled={disabled}
                style={{marginTop: 5, marginLeft: 'auto'}}
            >
              {t("Add")}
            </Button>
            <div style={{ width: "100%" }}>{renderTable}</div>
          </Grid>
        </Paper>
      </Fragment>
    );
  }, [form, householdComponent, error, disabled]);

  return (
    <Fragment>
      {renderHousehold}

      <MessageBox
        onClose={() => setDialogOpen(false)}
        title={t("Confirmation")}
        message={t("Do you really want to remove this item?")}
        haveAccept={{ yes: t("Submit"), no: t("Close") }}
        onAccept={deletePeople}
        open={dialogOpen}
      />

      <MessageBox
        onClose={() => setDialogHouseholdOpen(false)}
        title={t("Confirmation")}
        message={t("Do you really want to remove this whole household?")}
        haveAccept={{ yes: t("Submit"), no: t("Close") }}
        onAccept={deleteHousehold}
        open={dialogHouseholdOpen}
      />
    </Fragment>
  );
};

const initialUnknownPatientState = () => ({
  firstName: "",
  lastName: "",
  dob: null,
  yearOfBirth: "",
  speedRegistry: false,
});

const mnemonicValues = [
  "Alpha",
  "Bravo",
  "Delta",
  "Foxtrot",
  "Golf",
  "Hotel",
  "Kilo",
  "Lima",
  "Papa",
  "Quebec",
  "Sierra",
  "Tango",
  "Uniform",
  "Whiskey",
  "Yankee",
  "Zulu",
];

const phoneNumberTypes = [
  { value: "Home", label: "Home" },
  { value: "Work", label: "Work" },
  { value: "Mobile", label: "Mobile" },
  { value: "Other", label: "Other" },
  { value: "Alternate", label: "Alternate" },
];

const UnknownPatientBanner = memo((props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const version = dispatch(getEcdsVersion(null));

  const [unknownPatientState, setUnknownPatientState] = useState(() =>
      initialUnknownPatientState()
  );

  const {
    genderOptions,
    setAdmitToUnknown,
    setActiveStep,
    onClose,
    addAdmit,
    admit,
    setAdmit,
    admission,
    setAdmission,
    fastReg,
    speedRegFlag,
    arrivalModeOptions,
    isArrivalModeOptionsLoading,
    chiefComplaintOptions,
    isChiefComplaintOptionsLoading,
    temporaryPatientRef,
    temporaryPatientAttendanceRef,
    conveyingAmbulanceOptions,
    conveyingAmbulanceLoading,
  } = props;

  useEffect(() => {
    let patientObj;
    if (
      fastReg &&
      admit.firstName &&
      admit.familyName &&
      admit.dob &&
      admit.gender &&
      admit.hospitalNumber
    ) {
      patientObj = {
        firstName: admit.firstName,
        lastName: admit.familyName,
        dob: admit.dob,
        hospitalNumber: admit.hospitalNumber,
        gender:
          admit.gender.__description === "Male" ||
          admit.gender.__description === "Female"
            ? admit.gender
            : null,
      };
      setUnknownPatientState((prevState) => ({
        ...prevState,
        ...patientObj,
      }));
    }
  }, []);

  const handleUnknownPatientChange = (e) => {
    const { name, value } = e.target;

    setUnknownPatientState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const isPatientArrivedByAmbulance = () =>
    admission?.modeOfArrival?.group === "ambulance" || admission?.modeOfArrival?.ambulance;

  const handleToggleSpeedRegistry = (e) => {
    let admitObj = {
      ...admit,
      speedRegistry: e,
    };

    setAdmit(admitObj);
  };

  const handleRandomizeField = (field) => {
    const randomIndex = Math.floor(Math.random() * (mnemonicValues.length - 1));
    const randomValue = mnemonicValues[randomIndex];

    setUnknownPatientState((prevState) => ({
      ...prevState,
      [field]: randomValue,
    }));
  };

  const checkIfUnknownValid = () => {
    const { firstName, lastName, gender } = unknownPatientState;
    let formIsValid = true;

    if (
      !gender ||
      (gender.__description !== "Male" && gender.__description !== "Female")
    ) {
      formIsValid = false;
    }

    // if (
    //   admission.modeOfArrival &&
    //   admission.modeOfArrival.group === "ambulance"
    // ) {
    //   if (!admission.ambulanceIncidentNumber) {
    //     formIsValid = false;
    //   }
    // }

    if (fastReg || speedRegFlag) {
      if (!admission.chiefComplaint || !admission.modeOfArrival)
        formIsValid = false;
    }

    return !(!firstName || !lastName || !formIsValid);
  };

  const checkIfDateIsValid = () => {
    const unknownPatientYear = unknownPatientState.yearOfBirth;

    if (unknownPatientState.dob && unknownPatientState.dob.isValid()) {
      return true;
    }

    if (!unknownPatientYear || isNaN(unknownPatientYear)) {
      return false;
    }

    return !(
      +unknownPatientYear < 1890 ||
      +unknownPatientYear > new Date().getFullYear()
    );
  };

  const confirmSetUnknown = () => {
    let patientObj = {
      ...unknownPatientState,
      speedRegistry: admit.speedRegistry || speedRegFlag,
      hospitalNumber: admit.hospitalNumber
    };

    if (!checkIfDateIsValid()) {
      dispatch(
        setSnackbar({
          open: true,
          message: `Please enter a valid year of birth.`,
          type: "error",
        })
      );
      return;
    }
    if (!checkIfUnknownValid()) {
      dispatch(
        setSnackbar({
          open: true,
          message: `Please fill in all required fields.`,
          type: "error",
        })
      );
      return;
    }

    setAdmitToUnknown(patientObj);

    if (speedRegFlag || fastReg || admit.speedRegistry) {
      const objToAdmit = setAdmitToUnknown(patientObj, true);
      addAdmit({ ...objToAdmit, ...admission });
    } else {
      onClose();
      setActiveStep(2);
    }
  };

  const renderRandomSection = (field, label, hideButton) => {
    return (
      <>
        <Grid
          item
          xs={5}
          sx={{
            mt: field === "firstName" ? 3 : "",
            mb: 1,
          }}
        >
          <AgyleTextField
            onChange={handleUnknownPatientChange}
            name={field}
            value={unknownPatientState[field]}
            label={label}
            error={!unknownPatientState[field]}
            fullWidth
          >
            {t(label)}
          </AgyleTextField>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{
            mt: field === "firstName" ? 3 : "",
            mb: 1,
          }}
        >
          {!hideButton ? (
            <AgyleButton
                disabled={fastReg}
                onClick={() => handleRandomizeField(field)}
            >
              Randomize {label}
            </AgyleButton>
          ) : (
            <Typography variant="body2">
              {t(`Please fill ${label.toLowerCase()}.`)}
            </Typography>
          )}
        </Grid>
      </>
    );
  };

  const renderDictionaryFields = (field, label, dict, dictLoading) => {
    const ccDescription = version === 'V3' ? 'parentTerm' : 'snomedPreferredTerm';
    const handleDictChange = (_e, val) => {
      let admissionToSend = {
        ...admission,
        [field]: val,
      };

      setAdmission(admissionToSend);
    };

    // TO BE REMOVED LATER
    const dictOptions = field === "chiefComplaint" ?
        !_.isEmpty(dict) && dict.filter( item => item?.[ccDescription]?.toLowerCase() !== "not applicable to max terms") :
        dict;

    const localOptions = (prop, option, labelText,d) => {
      return (
          <li {...prop}>
            <span className={classes.ward}>
              {`${field === "chiefComplaint" ? option[ccDescription] : option?.__description}`}
            </span>
      </li>
      )
    }

    return (
      <>
        <Grid
          item
          xs={12}
          sx={{
            mt: field === "chiefComplaint" ? 1 : "",
            pr: 2,
          }}
        >
          <AgyleDictionaryField
            onChange={handleDictChange}
            options={dictOptions}
            name={field}
            loading={dictLoading}
            value={admission[field]}
            getOptionLabel={(option) => field === "chiefComplaint" ? option[ccDescription] : option.__description}
            label={label}
            error={!admission[field]}
            renderLocalOption={localOptions}
            groupBy={(option) => (field === 'chiefComplaint' || version === 'V4') && option.group}
          >
            {t(label)}
          </AgyleDictionaryField>
        </Grid>
        <Grid item xs={6} />
      </>
    );
  };

  useEffect(() => {
    const defaultGender =
      genderOptions &&
      genderOptions.find((item) => item.__description == "Not Known");

    if (defaultGender) {
      setUnknownPatientState((prevState) => ({
        ...prevState,
        gender: defaultGender,
      }));
    }

    if (speedRegFlag || fastReg) {
      setAdmission((prevState) => ({
        ...prevState,
        admitDate: moment(),
      }));
    }
  }, []);

  const getConveyingAmbulanceOptions = () => {
    if (admission.conveyingAmbulanceOrgId) {
      return _.find(conveyingAmbulanceOptions, {__description: admission.conveyingAmbulanceOrgId}) || null;
    }
    return null;
  };

  return (
    <>
      <DialogContent dividers className={"scroll-normal-white"}>
        {!fastReg && (
          <InformationBox type={"warning"}>
            <div className={clsx(classes.currentPatient)}>
              {speedRegFlag ? (
                <Typography variant="button" component="div">
                  {t("Temporary patient attendance.")}
                </Typography>
              ) : (
                <>
                  <Typography variant="button" component="div">
                    {t("Patient is unknown.")}
                  </Typography>
                  <Typography variant="body2" component="div">
                    {t(
                      "Please confirm you want to set patient as unknown and fill required fields."
                    )}
                  </Typography>
                </>
              )}
            </div>
          </InformationBox>
        )}

        <Grid
          container
          direction={"row"}
          justifyContent="space-between"
          alignItems="center"
          gap={1}
          style={{ paddingBottom: "20px" }}
        >
          {renderRandomSection(
            "firstName",
            "First Name",
            fastReg || speedRegFlag
          )}
          {renderRandomSection(
            "lastName",
            "Last Name",
            fastReg || speedRegFlag
          )}
          {!fastReg && !speedRegFlag ? (
            <Grid
              item
              xs={5}
              className={clsx(!fastReg && classes.unknownPatientDate)}
            >
              <Typography
                  variant="body1"
                  component="div"
                  sx={{ pt: 1.2, mr: 1, fontWeight: "bold" }}
                  textAlign="center"
              >
                01/01
              </Typography>

              <AgyleTextField
                onChange={(e) =>
                  setUnknownPatientState((prevState) => ({
                    ...prevState,
                    yearOfBirth: e.target.value,
                  }))
                }
                type="number"
                value={unknownPatientState["yearOfBirth"]}
                label="Year of Birth"
                error={!unknownPatientState.yearOfBirth}
                fullWidth
              />
            </Grid>
          ) : (
            <Grid item xs={5}>
              <AgyleDatePicker
                onChange={(e) =>
                  setUnknownPatientState((prevState) => ({
                    ...prevState,
                    dob: e,
                  }))
                }
                type="date"
                label={t("Date of birth")}
                maxDate={moment()}
                value={unknownPatientState.dob}
                error={!unknownPatientState.dob}
              />
            </Grid>
          )}
          <Grid
            item
            xs={6}
            sx={{ maxHeight: "32px" }}
          >
            <Typography variant={"body2"} component="div" textAlign="left">
              {t("Please select estimated year of birth.")}
            </Typography>
          </Grid>

          <Grid item xs={5} sx={{ mt: 1 }}>
            <AgyleDictionaryField
              onChange={(_e, val) =>
                setUnknownPatientState((prevState) => ({
                  ...prevState,
                  gender: val,
                }))
              }
              // disabled={fastReg && (
              //     unknownPatientState.gender || (
              //         unknownPatientState?.gender?.__description === "Male" && unknownPatientState?.gender?.__description === "Female"
              //     )
              // )}
              error={!unknownPatientState.gender}
              value={unknownPatientState.gender}
              options={genderOptions}
              label="Gender"
            />
          </Grid>

          <Grid item xs={6} sx={{ pt: 1 }}>
            <Typography variant={"body2"} component="div">
              {t("Please select patient's gender.")}
            </Typography>
          </Grid>
          {(speedRegFlag || fastReg) && (
            <>
              {renderDictionaryFields(
                "chiefComplaint",
                "Chief Complaint",
                chiefComplaintOptions,
                isChiefComplaintOptionsLoading
              )}
              {renderDictionaryFields(
                "modeOfArrival",
                "Arrival Mode",
                arrivalModeOptions,
                isArrivalModeOptionsLoading
              )}
              {
                <Grid item xs={12} sx={{ pr: 2 }}>
                  <AgyleDatePicker
                    onChange={(e) =>
                      setAdmission((prevState) => ({
                        ...prevState,
                        admitDate: e,
                      }))
                    }
                    label={t("Attendance Date")}
                    type={"dateTime"}
                    value={admission.admitDate}
                    error={!admission.admitDate}
                  />
                </Grid>
              }
              {isPatientArrivedByAmbulance() && (
                  <>
                    <Grid item xs={12} sx={{ pr: 2, pt: 1 }}>
                      <AgyleTextField
                          type="ambulance"
                          required
                          multiline
                          fullWidth
                          variant="outlined"
                          label={t("Ambulance Incident Number")}
                          error={!admission.ambulanceIncidentNumber && !(fastReg || speedRegFlag)}
                          value={admission.ambulanceIncidentNumber || ""}
                          onChange={(e) => {
                            const val = e.target.value;
                            const valCare = val ? `${val.replace('-', '')}-` : '';

                            setAdmission((prevState) => ({
                              ...prevState,
                              ambulanceIncidentNumber: val,
                              careContactIdentifier: valCare,
                            }))
                          }}
                      />
                    </Grid>

                    <Grid item xs={12} sx={{ pr: 2, pt: 1 }}>
                      <AgyleTextField
                          required
                          multiline
                          fullWidth
                          variant="outlined"
                          label={t('Care Contact Identifier')}
                          error={!admission.careContactIdentifier && !(fastReg || speedRegFlag)}
                          value={admission.careContactIdentifier || ""}
                          onChange={(e) =>
                              setAdmission((prevState) => ({
                                ...prevState,
                                careContactIdentifier: e.target.value,
                              }))
                          }
                          type="ambulance"
                      />
                    </Grid>

                    <Grid item xs={12} sx={{ pr: 2, pt: 1 }}>
                      <AgyleDictionaryField
                          label={`Org Id - Conveying Ambulance Trust`}
                          onChange={(_e, val) =>
                              setAdmission((prevState) => ({
                                ...prevState,
                                conveyingAmbulanceOrgId: val?.__description,
                              }))
                          }
                          options={conveyingAmbulanceOptions}
                          error={!admission.conveyingAmbulanceOrgId && !(fastReg || speedRegFlag)}
                          value={getConveyingAmbulanceOptions()}
                          required
                          loading={conveyingAmbulanceLoading}
                      />
                    </Grid>
                  </>
              )}

              <Grid item xs={12} sx={{ pr: 2, pt: 1 }}>
                <AgyleTextField
                    required
                    multiline
                    fullWidth
                    variant="outlined"
                    label={t('History of Presenting Complaint')}
                    value={admission?.historyOfPresentingComplaint}
                    onChange={(e) =>
                        setAdmission((prevState) => ({
                          ...prevState,
                          historyOfPresentingComplaint: e.target.value,
                        }))
                    }
                />
              </Grid>
            </>
          )}
        </Grid>
      </DialogContent>
      <DialogActions className={classes.dialogRoot}>
        <Button
          color="tertiary"
          onClick={() => {
            if (speedRegFlag || fastReg) {
              setActiveStep(0);
            }
            onClose();
          }}
        >
          {t("Close")}
        </Button>

        <div style={{ flex: "1 0 0" }} />

        {/*{!fastReg && !speedRegFlag && (*/}
        {/*  <>*/}
        {/*    <FormLabel sx={{ mr: 1 }}>{t("Speed Registry")}</FormLabel>*/}

        {/*    <AgyleBlockSwitch*/}
        {/*      onChange={handleToggleSpeedRegistry}*/}
        {/*      value={admit.speedRegistry || speedRegFlag}*/}
        {/*    />*/}
        {/*  </>*/}
        {/*)}*/}

        {!fastReg && !speedRegFlag ? (
          <Button
            color="tertiary"
            disabled={!checkIfUnknownValid()}
            onClick={confirmSetUnknown}
          >
            {t("Confirm")}
          </Button>
        ) : (
          <AgyleButton
            onClick={() => confirmSetUnknown()}
            variant="contained"
            disabled={!checkIfUnknownValid()}
          >
            {t("Create New Attendance")}
          </AgyleButton>
        )}
      </DialogActions>
    </>
  );
});

const DemographicDetails = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // DIALOG OPEN STATES
  const [isDialogOpen, openDialog, closeDialog] = useOpenState(false, false);
  const [isNhsResultsWarningOpen, openNhsResultsWarning, closeNhsResultsWarning] = useOpenState(false, false);
  const [isRemoveDialogOpen, openRemoveDialog, closeRemoveDialog] =
    useOpenState(false, false);

  const [nhsNumberDebounced] = useDebounce(props.admit?.nhsNumber, 500);

  // DICT VALUES
  const [ethnicOptions, isEthnicLoading] = useDict("EthnicGroups");
  const [languageOptions, isLanguageLoading] = useDict("Languages");
  const [genderOptions, isGenderLoading] = useDict(
    "Genders",
    "",
    "forAdmit eq true"
  );
  const [relationshipOptions, isRelationshipLoading] = useDict("Relationships");
  const [overseasOptions, isOverseasLoading] = useDict('OverseasVisitorChargingCategory', "", "forAdmit eq true");

  // HELPER INDEX STATE
  const [removedIndex, setRemovedIndex] = useState(null);

  const initPhone = {
    number: "",
    type: "Mobile",
  };
  const initEmail = {
    emailAddress: "",
  };
  const [phone, setPhone] = useState(initPhone);
  const [email, setEmail] = useState(initEmail);

  const nhsSearchResults = useRef(null);

  const {
    patientIsSelected,
    isPatientUpdated,
    addAdmit,
    admit,
    setAdmit,
    admission,
    setAdmission,
    setActiveStep,
    patientOnWhiteboard,
    isGenderMandatoryDialogOpen,
    closeGenderMandatoryDialog,
    speedRegFlag,
    fastReg,
    isTemporaryPatientEdit,
    temporaryPatientRef,
    temporaryPatientAttendanceRef,
    chiefComplaintOptions,
    isAddOnlyPatient,
    mergeToNewCreatedPatient,
    renderSuccessSnackbar,
    renderInfoSnackbar,
    renderErrorSnackbar,
    checkFields,
    conveyingAmbulanceOptions,
    conveyingAmbulanceLoading,
    validPostCode,
    setValidPostCode,
    validTemporaryPostCode,
    setValidTemporaryPostCode,
    toggleNFA,
    setToggleNFA,
    toggleNFATemporary,
    setToggleNFATemporary,
  } = props;

  const patientAge = moment().diff(admit.dob, "years");

  const requiredForChild = (field) => patientAge < 18 && !admit[field] && !(fastReg || speedRegFlag);

  const checkDisabled = (type) => {
    if ((type === 'contact' || type === 'phone') && config?.admitPatient?.contactNumbersReadOnly) return true

    if (patientIsSelected && mergeToNewCreatedPatient) {
      return !isPatientUpdated;
    }


    if (admit.patientUnknown || patientIsSelected || isTemporaryPatientEdit) {
      return !(isPatientUpdated || isTemporaryPatientEdit);
    }
    if (!patientIsSelected || (patientIsSelected && isPatientUpdated)) {
      return false;
    }
  };

  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (admit.patientUnknown || patientIsSelected || isTemporaryPatientEdit) {
      setDisabled(!(isPatientUpdated || isTemporaryPatientEdit));
    }
    if (!patientIsSelected || (patientIsSelected && isPatientUpdated)) {
      setDisabled(false);
    }
  }, [patientIsSelected, isTemporaryPatientEdit, admit.patientUnknown, isPatientUpdated]);

  const handleOpenODSPortal = () => {
    window.open(config?.odsPortalUrl, "_blank").focus();
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setAdmit({
      ...admit,
      [name]: value,
    });
  };

  const testPostalCode = (input) => {
    const regex = config?.admitPatient?.customPostalCodeRegex || /^[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}$/;
    return regex.test(input);
  }

  // Had to change to hook due "Save" button refreshment -> could save with wrong postal code
  useEffect(() => {
    if (config?.admitPatient?.postalCodeValidation) {
      setValidPostCode(_.isEmpty(admit?.postalCode) ? true : testPostalCode(admit?.postalCode));
      setValidTemporaryPostCode(_.isEmpty(admit?.postalCodeTemporary) ? true : testPostalCode(admit?.postalCodeTemporary));
    }
  }, [admit?.postalCodeTemporary, admit?.postalCode]);

  const handleChangeNhsNumber = (e) => {
    const cleanedNhs = e.target.value?.replace(/\s|[^0-9]/g, "");

    setAdmit(prevState => ({
        ...prevState,
        nhsNumber: cleanedNhs,
    }))
  }

  const handleChangeDob = (date) => {
    setAdmit((admit) => ({
      ...admit,
      dob: date,
    }));
  };

  const getAddressVal = (val, first) => {
    if (val) return `${first ? '' : ' '}${val}`;
    return '';
  };

  const handleChangeAddress = (e) => {
    if (e) {
      setValidPostCode(true);
      if (!e?.subBuildingName && !e?.buildingName) {
        setAdmit({
          ...admit,
          street: `${getAddressVal(e?.buildingNumber, true)}${getAddressVal(e?.thoroughfareAndDescriptor)}`,
          postTown: getAddressVal(e?.posttown, true),
          postalCode: getAddressVal(e?.postcode, true),
          city: '',
        });
      } else {
        setAdmit({
          ...admit,
          street: `${getAddressVal(e?.subBuildingName, true)}${getAddressVal(e?.buildingName)}`,
          postTown: `${getAddressVal(e?.buildingNumber, true)}${getAddressVal(e?.thoroughfareAndDescriptor)}`,
          postalCode: getAddressVal(e?.postcode, true),
          city: getAddressVal(e?.posttown, true),
        });
      }
    }
  };

  const handleChangeAddressNok = (e, index) => {
    if (e) {
      let list = _.cloneDeep(admit.nokList);
      list[index] = {
        ...list[index],
        street: `${getAddressVal(e?.subBuildingName, true)}${getAddressVal(e?.buildingNumber)}${getAddressVal(e?.buildingName)}${getAddressVal(e?.thoroughfareAndDescriptor)}`,
        postalCode: getAddressVal(e?.postcode, true),
        city: getAddressVal(e?.posttown, true),
      }

      setAdmit((prevState) => ({
        ...prevState,
        nokList: list,
      }));
    }
  };

  const setAdmitToUnknown = useCallback(
    (unknownPatientState, returnObj = false, noSet = false) => {
      const baseAdmitState = admitBase();
      const unknownDob = moment(`01-01-${unknownPatientState.yearOfBirth}`);

      const objToPass = {
        ...baseAdmitState,
        patientUnknown: true,
        firstName: unknownPatientState.firstName,
        familyName: unknownPatientState.lastName,
        dob: unknownPatientState.dob || unknownDob,
        hospitalNumber: unknownPatientState.hospitalNumber,
        gender: unknownPatientState.gender,
        speedRegistry: unknownPatientState.speedRegistry,
      };

      if (!noSet) {
        setAdmit(objToPass);
      }

      if (returnObj) {
        return objToPass;
      }
    },
    []
  );

  const handleAddNok = () => {
    const nokObject = {
      firstName: "",
      lastName: "",
      relationship: "",
      address: "",
      postalCode: "",
      phoneNumber: "",
    };

    if (!admit?.nokList || _.isEmpty(admit?.nokList)) {
      setAdmit((prevState) => ({
        ...prevState,
        nokList: [nokObject],
      }));
    } else {
      const newNokList = [...admit.nokList, nokObject];

      setAdmit((prevState) => ({
        ...prevState,
        nokList: newNokList,
      }));
    }
  };

  const handleChangeNok = (e, index) => {
    const { value, name } = e.target;
    const list = [...admit.nokList];

    list[index][name] = value;
    setAdmit((prevState) => ({
      ...prevState,
      nokList: list,
    }));
  };

  const handleChangeNokRelationship = (e, index) => {
    const list = [...admit.nokList];
    list[index].relationship = e;

    setAdmit((prevState) => ({
      ...prevState,
      nokList: list,
    }));
  };

  const handleRemoveNok = (index) => {
    const list = [...admit.nokList];
    const filteredList = list.filter((item, i) => i !== index);

    setAdmit((prevState) => ({
      ...prevState,
      nokList: filteredList,
    }));
  };

  const handleRemovePhoneNumber = (index) => {
    const list = [...admit.phoneNumbers];
    const filteredList = list.filter((item, i) => i !== index);

    setAdmit((prevState) => ({
      ...prevState,
      phoneNumbers: filteredList,
    }));
  };

  const handleRemoveEmail = (index) => {
    const list = [...admit.emailAdresses];
    const filteredList = list.filter((item, i) => i !== index);

    setAdmit((prevState) => ({
      ...prevState,
      emailAdresses: filteredList,
    }));
  };

  const handleSaveAddDialog = (addedItemKey) => {
    const value = addedItemKey === "email" ? email.emailAddress : phone.number;
    const itemKey = addedItemKey === "phone" ? "phoneNumbers" : "emailAdresses";

    if (!value) {
      return dispatch(
        setSnackbar({ message: "Please enter valid value.", type: "error" })
      );
    }

    let tempAdmitArray;
    if (!_.isEmpty(admit[itemKey])) {
      tempAdmitArray = [
        ...admit[itemKey],
        addedItemKey === "phone" ? phone : email,
      ];
    } else {
      tempAdmitArray = [addedItemKey === "phone" ? phone : email];
    }

    setAdmit((prevState) => ({
      ...prevState,
      [itemKey]: tempAdmitArray,
    }));

    if (addedItemKey === "phone") {
      setPhone(initPhone);
    } else {
      setEmail(initEmail);
    }
  };

  const handleChangeNhsStatus = (value) => {
    setAdmit((prevState) => ({
      ...prevState,
        nhsBlockedProceeding: value,
    }));
  }


  const searchForNhs = async (nhsNumber) => {
    let options = {
      resourceUri: "/patients",
      text: nhsNumber,
      page: 1,
      pageSize: 100,
      options: {},
      sort: "familyName"
    }

    try {
      const patients = await API.getSearchList(options)
      if (patients.status === 200) {
        nhsSearchResults.current = patients.data.collection['__data'].filter(element => { return !!element.nhsNumber });
        if (nhsSearchResults.current.length === 1) {
          renderInfoSnackbar("Patient found in database. Please select patient from search list.");
        }
        if (nhsSearchResults.current.length > 1) {
          renderInfoSnackbar("Multiple patients found in database. Please step to patient search and select valid patient from search list.");
        }
        handleChangeNhsStatus(true);
        openNhsResultsWarning();
      } else {
        handleChangeNhsStatus(false);
      }
  } catch (error) {
      console.log(error);
    }
}

useEffect(() => {
  if (config?.admitPatient?.searchDbForNhsOnFirstRegister && !patientIsSelected) {
    if (admit?.nhsNumber && nhsNumberDebounced && nhsNumberDebounced.length >= 10 &&
        admit?.nhsNumber === nhsNumberDebounced) {
      searchForNhs(nhsNumberDebounced.trim())
    }
  }
}, [props.patientIsSelected, config?.admitPatient?.searchDbForNhsOnFirstRegister, admit.nhsNumber, nhsNumberDebounced])

  useEffect(() => {
    const defaultEthnicGroup =
      ethnicOptions &&
      ethnicOptions.find((item) => item.__description === "British");

    const defaultLanguage =
      languageOptions &&
      languageOptions.find((item) => item.__description === "English");

    const defaultGender =
      genderOptions &&
      genderOptions.find((item) => item.__description === "Not Known");

    const defaultOverseas =
      overseasOptions &&
      overseasOptions.find(
        (item) => item.__description === "Standard NHS -funded"
      );

    // if (!admit.gender) {
    //   setAdmit((prevState) => ({
    //     ...prevState,
    //     gender: defaultGender,
    //   }));
    // }

    if (!admit.overseasStatus && !fastReg && !speedRegFlag) {
      if (isAddOnlyPatient || !patientIsSelected || mergeToNewCreatedPatient ) {
        return;
      }

      setAdmit((prevState) => ({
        ...prevState,
        overseasStatus: defaultOverseas,
      }));
    }

    if (admit && !admit.spokenLanguage && !fastReg && !speedRegFlag) {
      setAdmit((prevState) => ({
        ...prevState,
        spokenLanguage: defaultLanguage,
      }));
    }
  }, [languageOptions, overseasOptions]);

  useEffect(() => {
    const defaultLanguage =
      languageOptions &&
      languageOptions.find((item) => item.__description === "English");

    if (!admit?.spokenLanguageExists) {
      if (admit.patientNeedsInterpreter) {
        setAdmit((prevState) => ({
          ...prevState,
          spokenLanguage: null,
        }));
      } else {
        setAdmit((prevState) => ({
          ...prevState,
          spokenLanguage: defaultLanguage,
        }));
      }
    }
  }, [admit.patientNeedsInterpreter, languageOptions]);

  useEffect(() => {
    const changeEhic = () => {
      switch (admit.ehicCard) {
        case true:
          return setAdmit((prevState) => ({
            ...prevState,
            [prevState.noEhicReason]: "",
          }));
        case false:
          return setAdmit((prevState) => ({
            ...prevState,
            [prevState.ehicNumber]: "",
          }));
        case null:
          return setAdmit((prevState) => ({
            ...prevState,
            [prevState.ehicNumber]: "",
            [prevState.noEhicReason]: "",
          }));
        default:
          break;
      }
    };

    changeEhic();
  }, [admit.ehicCard]);

  useEffect(() => {
    if ((speedRegFlag || fastReg) && !admit.patientUnknown) {
      openDialog();
    }
  }, []);

  const renderSwitchField = (field, admitField, description, isError) => {
    const localValueField = field === "phone" ? "number" : "emailAddress";

    const changePhoneType = (e, localField, index) => {
      let numberList;
      const { value } = e.target;

      if (!_.isEmpty(admit.phoneNumbers) && field === "phone") {
        numberList = [...admit.phoneNumbers];

        const newNumber = {
          ...localField,
          type: value,
        };

        numberList.splice(index, 1, newNumber);

        setAdmit((prevState) => ({
          ...prevState,
          phoneNumbers: numberList,
        }));
      }
    };

    return (
      <>
        <Grid item xs={12} style={{ padding: field !== "phone" && 0 }} />
        <Grid item xs={12} sx={{ borderRadius: "10px" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
            sx={{ py: 0.5, mt: 1.5, flexWrap: "wrap", borderRadius: "10px" }}
            className={classes.whiteBorderContainer}
          >
            <Grid
              item
              xs={12}
              className={classes.phoneNumberContainer}
              sx={{ p: 1 }}
            >
              <AgyleTextField
                margin="dense"
                type={field === "email" ? "email" : "tel"}
                multiline
                disabled={checkDisabled(field)}
                error={isError}
                label={field === "email" ? "Email" : "Phone Number"}
                value={field === "email" ? email.emailAddress : phone.number}
                onChange={(e) => {
                  field === "email"
                    ? setEmail((prevState) => ({
                        ...prevState,
                        emailAddress: e.target.value,
                      }))
                    : setPhone((prevState) => ({
                        ...prevState,
                        number: e.target.value,
                      }));
                }}
              />

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                  alignItems: "center",
                }}
              >
                <AgyleButton
                  onClick={() => handleSaveAddDialog(field)}
                  variant={"contained"}
                  size="small"
                  disabled={checkDisabled(field)}
                >
                  {t(`+ ${description}`)}
                </AgyleButton>
              </div>
            </Grid>
          </Stack>

          <Stack direction="column" alignItems="flex-start" sx={{ mt: 2 }}>
            {!_.isEmpty(admit[admitField]) &&
              admit[admitField].map((localField, index) => (
                <Fragment key={localField[localValueField]}>
                  <Grid key={index + 'bcd'} item xs={12} sx={{ pl: 2 }}>
                    <div style={{ display: "flex", minWidth: "100%" }}>
                      <Typography
                        variant="h6"
                        component="div"
                        sx={{ pt: 0.5, mr: 2 }}
                      >
                        {index + 1}.
                      </Typography>

                      <div
                        className={classes.phoneNumberContainer}
                        style={{ minWidth: "27px" }}
                      >
                        <AgyleTextField
                          disabled
                          label={t(description)}
                          value={localField[localValueField]}
                          style={{
                            maxWidth: field === "phone" ? "180px" : "",
                            minWidth: field !== "phone" ? "240px" : ""
                          }}
                          onChange={() => console.error("Can't change field")}
                        />

                        {field === "phone" &&
                            <div style={{ minWidth: "100px" }}>
                              <AgyleTextField
                                  label={t("Phone type")}
                                  value={localField.type}
                                  select
                                  disabled={checkDisabled()}
                                  onChange={(e) =>
                                      changePhoneType(e, localField, index)
                              }
                              >
                                {phoneNumberTypes.map((option, index) => (
                                    <MenuItem
                                        key={option.value + index}
                                        value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                ))}
                              </AgyleTextField>
                            </div>
                        }

                        <IconButton
                          disabled={checkDisabled()}
                          onClick={() =>
                            field === "phone"
                              ? handleRemovePhoneNumber(index)
                              : handleRemoveEmail(index)
                          }
                          sx={{ ml: field !== "phone" ? -0.5 : 1 }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </div>
                    </div>
                  </Grid>

                  <Grid key={"divider" + index} item xs={12}>
                    <Divider sx={{ my: 2 }} />
                  </Grid>
                </Fragment>
              ))}
          </Stack>
        </Grid>
      </>
    );
  };

  const renderGpDetails = () => {
    if (!admit.gp) {
      return
    }

    const { address } = admit.gp;
    return (
        <>
          <Grid item xs={12} sm={6} md={4}>
            {admit.gp && <AgyleTextField
                size={"large"}
                multiline
                disabled
                fullWidth
                label={t("First Name")}
                value={admit.gp.firstName}
                onChange={() => {console.error("Can't change it.")}}
            />}
          </Grid>

           {admit.gp && admit.gp?.phoneNumber &&
                <Grid item xs={12} sm={6} md={4}>
                  <AgyleTextField
                    size={"large"}
                    multiline
                    fullWidth
                    label={t("GP Phone Contact")}
                    disabled
                    value={admit.gp?.phoneNumber}
                    onChange={() => {console.error("Can't change it.")}}
                />
                </Grid>
           }

           {admit.gp && admit.gp?.emailAddress &&
                <Grid item xs={12} sm={6} md={4}>
                  <AgyleTextField
                    size={"large"}
                    multiline
                    fullWidth
                    label={t("GP Email Contact")}
                    disabled
                    value={admit.gp?.emailAddress}
                    onChange={() => {console.error("Can't change it.")}}
                />
                </Grid>
           }

          <Grid item xs={12} sm={6} md={4}>
            {admit.gp && <AgyleTextField
                size={"large"}
                multiline
                disabled
                fullWidth
                label={t("Postal Code")}
                value={admit.gp?.address?.postalCode}
                onChange={() => {
                  console.error("Can't change it.");
                }}
            />}
          </Grid>

           {admit.gp?.address?.lines && admit.gp?.address?.lines.map((address, index) => {
             if (_.isEmpty(address)) return null;
                 return (
                     <Grid item xs={12} key={index}>
                       <AgyleTextField
                           size={"large"}
                           multiline
                           disabled
                           fullWidth
                           label={t(`Address line ` + (index + 1))}
                           value={address}
                           onChange={() => {
                             console.error("Can't change it.");
                           }}
                       />
                     </Grid>
                 );
               },
           )}
        </>
    )
  }

  const renderTemporaryPatientWarning = () => {
    const chiefComplaintValue = chiefComplaintOptions.find(chiefComplaint => chiefComplaint.__code === temporaryPatientAttendanceRef.current?.initialAEComplaintCode)
    const genderValue = genderOptions.find(gender => gender.__description === temporaryPatientRef.current.gender)

    return (
          <Grid container direction={"row"} gap={1.51}  justifyContent="flex-start" alignItems="stretch" sx={{background: '#FFC400', mt: 2, px: 2, py: 1, borderRadius: '10px'}}>
            <InformationBox type={"warning"}>
                <Typography variant="h6">
                  {t("CAUTION: Please compare and make sure that temporary and destination patient are correct.")}
                </Typography>
            </InformationBox>

            <Chip
                color={temporaryPatientRef.current?.firstName !== admit?.firstName ? "error" : "info"}
                label={<b>First Name: {temporaryPatientRef.current?.firstName}</b>}
                sx={{
                  width:{
                    xs:'300px',
                    sm: '250px'
                  },
                  height: 'auto',
                  padding: '6px 0',
                  '& .MuiChip-label': {
                    display: 'block',
                    whiteSpace: 'normal',
                  },
                }}
            />

            <Chip
                color={temporaryPatientRef.current?.familyName !== admit?.familyName ? "error" : "info"}
                label={<b>Family Name: {temporaryPatientRef.current?.familyName}</b>}
                sx={{
                  width:{
                    xs:'300px',
                    sm: '250px'
                  },
                  height: 'auto',
                  padding: '6px 0',
                  '& .MuiChip-label': {
                    display: 'block',
                    whiteSpace: 'normal',
                  },
                }}
            />

            <Chip
                color={moment(temporaryPatientRef.current?.dob).toISOString() !== moment(admit?.dob).toISOString() ? "error" : "info"}
                label={<b>Date of Birth: {moment(temporaryPatientRef.current?.dob).format("DD/MM/YYYY")}</b>}
                sx={{
                  width:{
                    xs:'300px',
                    sm: '250px'
                  },
                  height: 'auto',
                  padding: '6px 0',
                  '& .MuiChip-label': {
                    display: 'block',
                    whiteSpace: 'normal',
                  },
                }}
            />

            <Chip
                color={temporaryPatientRef.current?.gender !== admit.gender?.__description ? "error" : "info"}
                label={<b>Gender: {genderValue?.__description}</b>}
                style={{
                  minHeight: '100%'
                }}
                sx={{
                  width:{
                    xs:'300px',
                    sm: '250px'
                  },
                  height: 'auto',
                  padding: '6px 0',
                  '& .MuiChip-label': {
                    display: 'block',
                    whiteSpace: 'normal',
                  },
                }}
            />

            <Chip
                color="info"
                label={<b>Chief Complaint: {chiefComplaintValue?.parentTerm}</b>}
                sx={{
                  width:{
                    xs:'300px',
                    sm: '250px'
                  },
                  height: 'auto',
                  padding: '6px 0',
                  '& .MuiChip-label': {
                    display: 'block',
                    whiteSpace: 'normal',
                  },
                }}
            />
          </Grid>
    )
  }

  useEffect(() => {
    if (admit.ehicNumber) {
      setAdmit(prevState => ({
        ...prevState,
        ehicCard: true
      }))
    }
  }, [])

  const genderValueValid = () => {
    if (!patientIsSelected) return true;

    const patientGender = admit.gender;
    const isMaleOrFemale = patientGender?.__description === 'Male' || patientGender?.__description === 'Female';

    if (!isMaleOrFemale) {
      return false;
    }

    return true;
  }

  const handleToggleTemporaryAddressButton = () => {
    if (_.isNil(admit?.streetTemporary) || _.isNil(admit?.postTownTemporary) || _.isNil(admit?.cityTemporary) || _.isNil(admit?.countyTemporary) || _.isNil(admit?.postalCodeTemporary)) {
      setAdmit(prevState => ({
        ...prevState,
        streetTemporary: "",
        postTownTemporary: "",
        cityTemporary: "",
        countyTemporary: "",
        postalCodeTemporary: ""
      }))
    } else {
        setAdmit(prevState => ({
            ...prevState,
            streetTemporary: null,
            postTownTemporary: null,
            cityTemporary: null,
            countyTemporary: null,
            postalCodeTemporary: null
        }))
    }
  }

  const handleToggleNFA = (val, isPrimary) => {
    if (isPrimary) {
      setToggleNFA(val);
      if (val) handleChangeInput({target: {name: 'postalCode', value: 'ZZ99 '}});
    } else {
      setToggleNFATemporary(val);
      if (val) handleChangeInput({target: {name: 'postalCodeTemporary', value: 'ZZ99 '}});
    }
  };

  const getTempAddressLabel = () => _.isNil(admit?.streetTemporary) ? t("Add Temporary Address") : t("Remove Temporary Address")

  const renderTemporaryAddressSection = () => (
      <>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Divider textAlign="left">{t("Temporary Address")}</Divider>
        </Grid>

        <Grid item xs={12} sx={{mt: 2, my: 1}}>
          <AgyleButton
              onClick={handleToggleTemporaryAddressButton}
              variant="contained"
              disabled={checkDisabled()}
          >
            {getTempAddressLabel()}
          </AgyleButton>
        </Grid>

        <Grid item xs={12} sm={6}>
          {!_.isNil(admit?.streetTemporary) && <AgyleTextField
              size="large"
              disabled={checkDisabled()}
              fullWidth
              label={t('Temporary Address Line 1')}
              value={admit?.streetTemporary}
              error={!admit?.streetTemporary}
              name="streetTemporary"
              onChange={handleChangeInput}
              style={{marginBottom: 10}}
              shrink
          />}

          {!_.isNil(admit?.streetTemporary) && <AgyleTextField
              size="large"
              disabled={checkDisabled()}
              fullWidth
              label={t('Temporary Address Line 2')}
              value={admit?.postTownTemporary}
              name="postTownTemporary"
              onChange={handleChangeInput}
              style={{marginBottom: 10}}
              shrink
          />}

          {!_.isNil(admit?.streetTemporary) && <AgyleTextField
              size="large"
              disabled={checkDisabled()}
              fullWidth
              label={t('Temporary Address Line 3')}
              value={admit?.cityTemporary}
              name="cityTemporary"
              onChange={handleChangeInput}
              style={{marginBottom: 10}}
              shrink
          />}

          {!_.isNil(admit?.streetTemporary) && <AgyleTextField
              size="large"
              disabled={checkDisabled()}
              fullWidth
              label={t('Temporary Address Line 4')}
              value={admit?.countyTemporary}
              name="countyTemporary"
              onChange={handleChangeInput}
              style={{marginBottom: 10}}
              shrink
          />}

          {!_.isNil(admit?.streetTemporary) && <AgyleTextField
              size="large"
              disabled={checkDisabled()}
              fullWidth
              label={t('Temporary Postal Code')}
              error={!admit?.postalCodeTemporary || (!validTemporaryPostCode && !toggleNFATemporary)}
              value={admit?.postalCodeTemporary}
              name="postalCodeTemporary"
              onChange={handleChangeInput}
              shrink
              helperText={((!validTemporaryPostCode && !toggleNFATemporary) && !_.isEmpty(admit.postalCodeTemporary)) ? 'Invalid Postal Code' : ''}
          />}

          {(!_.isNil(admit?.streetTemporary) && config?.admitPatient?.enableNFAButtonTemporary) &&
              <div className={classes.buttonNFA}>
                <AgyleBlockSwitch
                    value={toggleNFATemporary}
                    onChange={handleToggleNFA}
                    customLabels={{yes: 'NFA', no: 'N/R'}}
                    disabled={checkDisabled()}
                />

                <FormLabel style={{marginLeft: 5}}>
                  {t('No fixed abode')}
                </FormLabel>
              </div>
          }
        </Grid>
      </>
  )

  return (
    <Paper>
      <div className={classes.content}>
        <Grid container spacing={2}>
          <div className={classes.bannerContainer}>
            {temporaryPatientRef.current && renderTemporaryPatientWarning()}

            {patientOnWhiteboard && (
              <InformationBox type={"warning"}>
                <Typography variant="h6">
                  {t(
                    "Caution! This patient already has active attendance. Make sure to check whether patient data is correct."
                  )}
                </Typography>
              </InformationBox>
            )}

            {isPatientUpdated && (
              <InformationBox type={"warning"}>
                <Typography variant="h6">
                  {t(
                    "Caution! You are editing patient data! Make sure to check whether patient data is correct."
                  )}
                </Typography>
              </InformationBox>
            )}
          </div>

          <Grid item xs={12}>
            <Divider textAlign="left">Personal Details</Divider>
          </Grid>

          {!patientIsSelected && (
            <Grid
              item
              xs={12}
              md={7}
              sx={{ my: 2 }}
              style={{ flexBasis: "content" }}
            >
              <Grid
                container
                direction="row"
                alignItems="center"
              >
                <div style={{ minWidth: "160px" }}>
                  <AgyleBlockSwitch
                    disabled={checkDisabled()}
                    onChange={() => {
                      openDialog();
                    }}
                    value={admit.patientUnknown}
                  />
                </div>
                <FormLabel sx={{ minWidth: "185px" }}>
                  {t("Patient is unknown")}
                </FormLabel>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12} style={{ padding: 0 }} />

          <Grid item xs={12}>
            <Grid container alignItems="center" justifyContent="flex-start">
              <Grid item xs={12} md={4} lg={4}>
                <Grid
                  container
                  alignItems="center"
                  style={{ minHeight: "46px" }}
                >
                  <div style={{ minWidth: "160px" }}>
                    <AgyleBlockSwitch
                      disabled={checkDisabled()}
                      onChange={(val) => {
                        setAdmit((prevState) => ({
                          ...prevState,
                          patientNeedsInterpreter: val,
                        }));
                      }}
                      value={admit.patientNeedsInterpreter}
                      customLabels={{empty: t('Declined')}}
                      nullState
                      sx={{ flexGrow: 2 }}
                    />
                  </div>

                  <FormLabel sx={{ mr: 1 }} style={{ minWidth: "min-content" }}>
                    {t("Patient needs interpreter")}
                  </FormLabel>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                md={4}
                sx={{ py: 0.5 }}
                minHeight={{ xs: 0, lg: "64px" }}
                pl={{ xs: 0, lg: 1 }}
              >
                <AgyleDictionaryField
                  onChange={(_e, val) =>
                    setAdmit((prevState) => ({
                      ...prevState,
                      spokenLanguage: val,
                    }))
                  }
                  size={"large"}
                  options={languageOptions}
                  value={admit?.spokenLanguage || null}
                  label={t("Preferred Spoken Language")}
                  disabled={checkDisabled()}
                  loading={isLanguageLoading}
                />
              </Grid>

              {admit.patientNeedsInterpreter &&
                <Grid
                  item
                  xs={12}
                  md={4}
                  sx={{ py: 0.5 }}
                  minHeight={{ xs: 0, lg: "64px" }}
                  pl={{ xs: 0, lg: 1 }}
                >
                  <AgyleDictionaryField
                    onChange={(_e, val) =>
                      setAdmit((prevState) => ({
                        ...prevState,
                        interpreterLanguage: val,
                      }))
                    }
                    disabled={checkDisabled()}
                    size={"large"}
                    options={languageOptions}
                    value={admit?.interpreterLanguage || null}
                    label={t("Interpreter Language")}
                    loading={isLanguageLoading}
                  />
                </Grid>
              }
            </Grid>
          </Grid>

          <Grid item xs={12} lg={8}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid
                item
                xs={12}
                md={6}
              >
                <Grid
                  container
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                    gap: 2,
                    minHeight: "46px",
                  }}
                >
                  <div style={{ minWidth: "160px" }}>
                    <AgyleBlockSwitch
                      disabled={checkDisabled()}
                      padding
                      onChange={(e) => {
                        setAdmit((prevState) => ({
                          ...prevState,
                          ehicCard: e,
                        }));
                      }}
                      value={admit.ehicCard}
                      nullState
                      customLabels={!true ? { no: t("N/R") } : null}
                    />
                  </div>
                  <FormLabel
                    sx={{ mr: 1 }}
                  >
                    {t("EHIC Card")}
                  </FormLabel>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                paddingLeft={{ xs: 0, lg: 1 }}
                sx={{ pb: 0.5 }}
                minHeight={{ xs: 0, md: "64px" }}
              >
                {admit.ehicCard && (
                  <AgyleTextField
                    size={"large"}
                    variant="outlined"
                    label={"EHIC Number"}
                    fullWidth
                    disabled={checkDisabled()}
                    error={!admit.ehicNumber}
                    className={classes.formControl}
                    value={admit.ehicNumber}
                    name={"ehicNumber"}
                    onChange={handleChangeInput}
                    InputLabelProps={{ shrink: true }}
                  />
                )}

                {admit.ehicCard === false && (
                  <AgyleTextField
                    size={"large"}
                    multiline
                    fullWidth
                    variant="outlined"
                    disabled={checkDisabled()}
                    error={!admit.noEhicReason}
                    label={"Reason for not providing EHIC Card"}
                    className={classes.formControl}
                    name="noEhicReason"
                    value={admit.noEhicReason}
                    onChange={handleChangeInput}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
                {/*)}*/}
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} style={{ maxHeight: 0, margin: 0, padding: 0 }} />

          <Grid item xs={12} sm={6} md={4}>
            <AgyleTextField
              size={"large"}
              fullWidth
              disabled
              readOnly
              variant="outlined"
              label={"Hospital Number"}
              className={classes.formControl}
              onChange={() => console.error("Cannot change this field")}
              value={admit.hospitalNumber}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AgyleTextField
              size={"large"}
              fullWidth
              multiline
              disabled={checkDisabled() || patientIsSelected && !props.nhsNumberValid() && !isPatientUpdated}
              readOnly={patientIsSelected && !props.nhsNumberValid() && !isPatientUpdated}
              variant="outlined"
              label={"NHS Number"}
              className={classes.formControl}
              value={admit.nhsNumber}
              name={"nhsNumber"}
              error={props.nhsNumberValid()}
              onChange={handleChangeNhsNumber}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AgyleDatePicker
              label={`Date of Birth`}
              size={"large"}
              onChange={handleChangeDob}
              error={!admit.dob}
              disabled={checkDisabled() || (patientIsSelected && !mergeToNewCreatedPatient)}
              readOnly={(patientIsSelected && !mergeToNewCreatedPatient)}
              value={admit.dob}
              type="date"
              disableFuture={true}
              maxDate={moment()}
              minDate={moment().subtract(140, "years")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AgyleTextField
              size={"large"}
              fullWidth
              multiline
              disabled={checkDisabled() || (patientIsSelected && !mergeToNewCreatedPatient)}
              readOnly={(patientIsSelected && !mergeToNewCreatedPatient)}
              variant="outlined"
              label={"First Name"}
              className={classes.formControl}
              value={admit.firstName}
              error={!admit.firstName}
              name={"firstName"}
              onChange={handleChangeInput}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AgyleTextField
              size={"large"}
              fullWidth
              multiline
              disabled={checkDisabled() || (patientIsSelected && !mergeToNewCreatedPatient)}
              readOnly={(patientIsSelected && !mergeToNewCreatedPatient)}
              variant="outlined"
              label={"Middle Name"}
              className={classes.formControl}
              value={admit.middleNames}
              name={"middleNames"}
              onChange={handleChangeInput}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AgyleTextField
              multiline
              disabled={checkDisabled() || (patientIsSelected && !mergeToNewCreatedPatient)}
              readOnly={(patientIsSelected && !mergeToNewCreatedPatient)}
              variant="outlined"
              label={"Family Name"}
              error={!admit.familyName}
              fullWidth
              className={classes.formControl}
              value={admit.familyName}
              name={"familyName"}
              onChange={handleChangeInput}
              InputLabelProps={{ shrink: true }}
              size={"large"}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AgyleDictionaryField
              onChange={(_e, val) => {
                setAdmit((prevState) => ({
                  ...prevState,
                  gender: val,
                }));
              }}
              options={genderOptions}
              disabled={checkDisabled() || ((patientIsSelected && !mergeToNewCreatedPatient) && genderValueValid())}
              readOnly={(patientIsSelected && !mergeToNewCreatedPatient) && genderValueValid()}
              size={"large"}
              error={!admit.gender}
              value={admit.gender}
              label={t("Gender")}
              loading={isGenderLoading}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AgyleDictionaryField
              onChange={(_e, val) => {
                setAdmit((prevState) => ({
                  ...prevState,
                  ethnicGroup: val,
                }));
              }}
              options={ethnicOptions}
              disabled={checkDisabled()}
              size={"large"}
              value={admit.ethnicGroup}
              error={!admit.ethnicGroup}
              label={t("Ethnic Group")}
              loading={isEthnicLoading}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AgyleDictionaryField
              onChange={(_e, val) => {
                setAdmit((prevState) => ({
                  ...prevState,
                  overseasStatus: val,
                }));
              }}
              options={overseasOptions}
              disabled={checkDisabled()}
              size={"large"}
              error={!admit.overseasStatus}
              value={admit.overseasStatus}
              label={t("Overseas Visitor Charging Category")}
              loading={isOverseasLoading}
            />
          </Grid>

          {/*<Grid item xs={12} sm={6} md={4}>*/}
          <Grid item xs={12} sm={6} md={4}>
            <AccommodationStatus
                label={t('Accommodation status')}
                value={admit.accommodationStatus}
                onChange={(_e, val) => {
                  setAdmit({
                    ...admit,
                    accommodationStatus: val,
                  });
                }}
                size="large"
                noCodes
                disabled={checkDisabled() || isAddOnlyPatient || !patientIsSelected}
            />
          </Grid>

          {(isAddOnlyPatient || !patientIsSelected || mergeToNewCreatedPatient) &&
            <Grid item xs={12}>
              <InformationBox type={"info"}>
                <Typography variant="h6">
                  {t(
                    "Optional elements of patient data only available to record on patient update."
                  )}
                </Typography>
              </InformationBox>
            </Grid>}

          {/*<Grid item xs={12} sm={6} md={6}>*/}
          {/*  <AgyleTextField*/}
          {/*    size={"large"}*/}
          {/*    multiline*/}
          {/*    disabled={checkDisabled()}*/}
          {/*    fullWidth*/}
          {/*    // disabled={isDataUpToDate}*/}
          {/*    name={"occupation"}*/}
          {/*    value={admit.occupation}*/}
          {/*    onChange={handleChangeInput}*/}
          {/*    label={"Occupation"}*/}
          {/*    variant="outlined"*/}
          {/*  />*/}
          {/*</Grid>*/}

          <Grid item xs={12} />

          <Grid item xs={12} sx={{ mt: 2 }}>
            <Divider textAlign="left">Contact</Divider>
          </Grid>

          {config.modules?.postCodeFinder?.enabled &&
            <Grid item xs={12}>
              <AddressFinderControl
                  size="large"
                  placeholder={t("Find Address")}
                  onChange={handleChangeAddress}
                  disabled={checkDisabled()}
              />
            </Grid>
          }

          <Grid item xs={12} sx={{ mt: 2 }}>
            <Divider textAlign="left">{t("Primary Address")}</Divider>
          </Grid>

          <Grid item xs={12} sm={6}>
            <AgyleTextField
                size="large"
                disabled={checkDisabled()}
                fullWidth
                label={t('Address Line 1')}
                value={admit.street}
                error={!admit.street && _.isNil(admit?.streetTemporary)}
                name="street"
                onChange={handleChangeInput}
                style={{marginBottom: 10}}
                shrink
            />

            <AgyleTextField
                size="large"
                disabled={checkDisabled()}
                fullWidth
                label={t('Address Line 2')}
                value={admit.postTown}
                name="postTown"
                onChange={handleChangeInput}
                style={{marginBottom: 10}}
                shrink
            />

            <AgyleTextField
                size="large"
                disabled={checkDisabled()}
                fullWidth
                label={t('Address Line 3')}
                value={admit.city}
                name="city"
                onChange={handleChangeInput}
                style={{marginBottom: 10}}
                shrink
            />

            <AgyleTextField
                size="large"
                disabled={checkDisabled()}
                fullWidth
                label={t('Address Line 4')}
                value={admit.county}
                name="county"
                onChange={handleChangeInput}
                style={{marginBottom: 10}}
                shrink
            />

            <AgyleTextField
                size="large"
                disabled={checkDisabled()}
                fullWidth
                label={t('Postal Code')}
                error={(!admit?.postalCode && _.isNil(admit?.streetTemporary)) || (!validPostCode && !toggleNFA)}
                value={admit.postalCode}
                name="postalCode"
                onChange={handleChangeInput}
                shrink
                helperText={((!validPostCode && !toggleNFA) && !_.isEmpty(admit.postalCode)) ? 'Invalid Postal Code' : ''}
            />

            {config?.admitPatient?.enableNFAButton &&
                <div className={classes.buttonNFA}>
                  <AgyleBlockSwitch
                      value={toggleNFA}
                      onChange={e => handleToggleNFA(e, true)}
                      customLabels={{yes: 'NFA', no: 'N/R'}}
                      disabled={checkDisabled()}
                  />

                  <FormLabel style={{marginLeft: 5}}>
                    {t('No fixed abode')}
                  </FormLabel>
                </div>
            }
          </Grid>

          <Grid item xs={12} sm={6}>
            <InformationBox type="info" noMargin>
              {t('Address Line 1 & Postal Code are mandatory in the address fields.')}
            </InformationBox>

            {renderSwitchField("phone", "phoneNumbers", "Phone Number", (_.isEmpty(admit.phoneNumbers) && !phone.number) && !config?.admitPatient?.contactNumbersReadOnly && config?.admitPatient?.contactNumberMandatory)}
          </Grid>

          {config?.admitPatient?.temporaryAddressEnabled && renderTemporaryAddressSection()}

          {/*MULTIPLE NEXT OF KIN*/}

          <Grid item xs={12}>
            <Divider textAlign="left">{t("GP & Surgery")}</Divider>
          </Grid>

          {(!admit.surgery || !admit.gp) && <Grid item xs={12}>
            <InformationBox type="info" noMargin>
              {t('GP surgery and GP are mandatory in the registration process.')}
            </InformationBox>
          </Grid>}

          <Grid item xs={12}>
            <ControlSurgery
                label={t('Select Practice')}
                disabled={checkDisabled()}
                value={admit.surgery}
                error={!admit.surgery}
                gp={admit.gp}
                onChange={(e) => setAdmit(prevState => ({
                      ...prevState,
                      surgery: e
                    }
                ))}
                dontTrimSearch
            />
          </Grid>

          <Grid item xs={12}>
            <ControlGP
                label={t('Select GP')}
                disabled={checkDisabled()}
                value={admit.gp}
                error={!admit.gp}
                surgery={admit.surgery}
                onChange={(e) => setAdmit(prevState => ({
                      ...prevState,
                      gp: e
                    }
                ))}
                dontTrimSearch
            />
          </Grid>

          <Grid item xs={12}>
            <AgyleButton
                onClick={handleOpenODSPortal}
                variant="contained"
                selected
            >
              {t("Open ODS")}
            </AgyleButton>
          </Grid>

          {renderGpDetails()}

          <Grid item xs={12}>
            <Divider textAlign="left">{t("Next of Kin")}</Divider>
          </Grid>

          {_.isEmpty(admit.nokList) && <Grid item xs={12}>
            <InformationBox type="info" noMargin>
              {t('At least one Next of Kin is mandatory in the registration process.')}
            </InformationBox>
          </Grid>}

          <Grid item xs={12} md={2} sx={{ mt: 2 }}>
            <AgyleButton
              disabled={checkDisabled()}
              variant="contained"
              onClick={() => handleAddNok()}
            >
              {t("+ Next of Kin")}
            </AgyleButton>
          </Grid>

          <Grid item xs={12} md={10}>
            <List xs={12}>
              {!_.isEmpty(admit.nokList) &&
                admit.nokList.map((nok, index) => {
                  return (
                    <ListItem
                      xs={12}
                      sx={{ gap: 1, flexWrap: "wrap" }}
                      components="nav"
                      key={index + "nokIndex"}
                    >
                      <Grid container spacing={2} sx={{ m: 2, mt: 0 }}>
                        <Grid item xs={11}>
                          <Divider textAlign="center">{index + 1}</Divider>
                        </Grid>

                        <Grid item xs={1} sx={{ p: 1 }}>
                          <IconButton
                            disabled={checkDisabled()}
                            onClick={() => {
                              if (checkDisabled()) {
                                return;
                              }
                              setRemovedIndex(index);
                              openRemoveDialog();
                            }}
                          >
                            <AgyleNamedIcon name="trashBin" withTooltip />
                          </IconButton>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <AgyleTextField
                            size={"large"}
                            fullWidth
                            multiline
                            disabled={checkDisabled()}
                            variant="outlined"
                            label={"First Name"}
                            className={classes.formControl}
                            value={nok?.firstName}
                            name={"firstName"}
                            onChange={(e) => handleChangeNok(e, index)}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <AgyleTextField
                            size={"large"}
                            fullWidth
                            multiline
                            disabled={checkDisabled()}
                            variant="outlined"
                            label={"Last Name"}
                            className={classes.formControl}
                            value={nok?.lastName}
                            name={"lastName"}
                            onChange={(e) => handleChangeNok(e, index)}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <AgyleDictionaryField
                            onChange={(_e, val) =>
                              handleChangeNokRelationship(val, index)
                            }
                            size={"large"}
                            options={relationshipOptions}
                            required
                            error={!nok?.relationship}
                            value={nok?.relationship || null}
                            label={t("Relationship")}
                            disabled={checkDisabled()}
                            loading={isRelationshipLoading}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <AgyleTextField
                            size={"large"}
                            fullWidth
                            multiline
                            disabled={checkDisabled("contact")}
                            variant="outlined"
                            label={"Contact"}
                            className={classes.formControl}
                            value={nok?.phoneNumber}
                            name={"phoneNumber"}
                            onChange={(e) => handleChangeNok(e, index)}
                            InputLabelProps={{ shrink: true }}
                            required={config?.admitPatient?.nokContactNumberMandatory}
                            error={config?.admitPatient?.nokContactNumberMandatory && !nok.phoneNumber}
                          />
                        </Grid>

                        {config.modules?.postCodeFinder?.enabled &&
                            <Grid item xs={12}>
                              <AddressFinderControl
                                  size="large"
                                  placeholder={t("Find Address")}
                                  onChange={e => handleChangeAddressNok(e, index)}
                                  disabled={checkDisabled()}
                              />
                            </Grid>
                        }

                        <Grid item xs={12} sm={6}>
                          <AgyleTextField
                            size={"large"}
                            multiline
                            disabled={checkDisabled()}
                            fullWidth
                            variant="outlined"
                            label={"Street"}
                            className={classes.formControl}
                            value={nok?.street}
                            name={"street"}
                            onChange={(e) => handleChangeNok(e, index)}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <AgyleTextField
                            size={"large"}
                            multiline
                            disabled={checkDisabled()}
                            fullWidth
                            variant="outlined"
                            label={"City"}
                            className={classes.formControl}
                            value={nok?.city}
                            name={"city"}
                            onChange={(e) => handleChangeNok(e, index)}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <AgyleTextField
                            size={"large"}
                            fullWidth
                            multiline
                            disabled={checkDisabled()}
                            variant="outlined"
                            label={"Postal Code"}
                            className={classes.formControl}
                            value={nok?.postalCode}
                            name={"postalCode"}
                            onChange={(e) => handleChangeNok(e, index)}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <AgyleTextField
                            size={"large"}
                            multiline
                            disabled={checkDisabled()}
                            fullWidth
                            variant="outlined"
                            label={"County"}
                            className={classes.formControl}
                            value={nok?.county}
                            name={"county"}
                            onChange={(e) => handleChangeNok(e, index)}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <AgyleTextField
                            size={"large"}
                            multiline
                            disabled={checkDisabled()}
                            fullWidth
                            variant="outlined"
                            label={"Post Town"}
                            className={classes.formControl}
                            value={nok?.postTown}
                            name={"postTown"}
                            onChange={(e) => handleChangeNok(e, index)}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                  );
                })}
            </List>
          </Grid>

          {admit.dob && isChild(patientAge) && (
            <Grid item xs={12} sx={{ m: 2 }}>
              <ChildAccordion
                admit={admit}
                setAdmit={setAdmit}
                handleChangeInput={handleChangeInput}
                isChild={isChild}
                checkDisabled={checkDisabled}
                disabled={disabled}
                patientIsSelected={patientIsSelected}
                isAddOnlyPatient={isAddOnlyPatient}
                mergeToNewCreatedPatient={mergeToNewCreatedPatient}
              />
            </Grid>
          )}

          {config?.admitPatient.adultAccordion && admit.dob && !isChild(patientAge) && (
            <Grid item xs={12} sx={{ m: 2 }}>
              <AdultAccordion
                admit={admit}
                setAdmit={setAdmit}
                handleChangeInput={handleChangeInput}
                isChild={isChild}
                checkDisabled={checkDisabled}
              />
            </Grid>
          )}

          {isRemoveDialogOpen && (
            <Dialog
              open={isRemoveDialogOpen}
              onClose={closeRemoveDialog}
              disableEscapeKeyDown
            >
              <DialogContent dividers>
                <InformationBox type={"warning"} xs={12}>
                  <div className={clsx(classes.currentPatient)}>
                    <Typography variant="button" component="div">
                      {t("Remove Next of Kin entry.")}
                    </Typography>
                    <Typography variant="body2" component="div">
                      {t(
                        "Please confirm you want to remove following Next of Kin entry."
                      )}
                    </Typography>
                  </div>
                </InformationBox>

                <Grid
                  container
                  direction={"column"}
                  justifyContent="center"
                  alignItems="flex-start"
                  gap={1}
                  sx={{ pl: 1 }}
                >
                  <Chip
                    className={classes.infoPt}
                    label={`First Name: ${
                      admit.nokList[removedIndex]?.firstName ||
                      "no first name was given"
                    }`}
                  />
                  <Chip
                    className={classes.infoPt}
                    label={`Last Name: ${
                      admit.nokList[removedIndex]?.lastName ||
                      "no last name was given"
                    }`}
                  />
                  <Chip
                    className={classes.infoPt}
                    label={`Address: ${
                      admit.nokList[removedIndex]?.address ||
                      "no address was given"
                    }`}
                  />
                  <Chip
                    className={classes.infoPt}
                    label={`Postal Code: ${
                      admit.nokList[removedIndex]?.postalCode ||
                      "no postal code was given"
                    }`}
                  />
                  <Chip
                    className={classes.infoPt}
                    label={`Phone Number: ${
                      admit.nokList[removedIndex]?.phoneNumber ||
                      "no phone number was given"
                    } `}
                  />
                  <Chip
                    className={classes.infoPt}
                    label={`Relationship: ${
                      admit.nokList[removedIndex].relationship?.__description ||
                      "no relationship was given"
                    }`}
                  />
                </Grid>
              </DialogContent>

              <DialogActions className={classes.dialogRoot}>
                <Button
                  color="tertiary"
                  onClick={() => {
                    closeRemoveDialog();
                  }}
                >
                  {t("Close")}
                </Button>

                <Button
                  color="tertiary"
                  onClick={() => {
                    // setAdmitToUnknown();
                    handleRemoveNok(removedIndex);
                    closeRemoveDialog();
                    setRemovedIndex(null);
                  }}
                >
                  {t("Confirm")}
                </Button>
              </DialogActions>
            </Dialog>
          )}

          <Dialog
            open={isGenderMandatoryDialogOpen}
            onClose={closeGenderMandatoryDialog}
            disableEscapeKeyDown
          >
            <DialogTitle
              className={clsx(classes.background, classes.dialogTitle)}
            >
              {t("Gender not valid")}
            </DialogTitle>
            <DialogContent
              className={clsx(classes.background, classes.dialogContent, "scroll-normal-white")}
              dividers
            >
              <InformationBox type={"warning"} xs={12}>
                <div className={clsx(classes.currentPatient)}>
                  <Typography variant="button" component="div">
                    {t(
                      "Please update patient's data and select valid gender to proceed."
                    )}
                  </Typography>
                </div>
              </InformationBox>
            </DialogContent>
            <DialogActions
              className={clsx(classes.background, classes.dialogContent)}
            >
              <AgyleButton
                variant="contained"
                onClick={closeGenderMandatoryDialog}
              >
                {t("Close")}
              </AgyleButton>
            </DialogActions>
          </Dialog>

            <MessageBox
                open={isNhsResultsWarningOpen}
                onClose={closeNhsResultsWarning}
                title={t("NHS Number results warning.")}
                type={"warning"}
                haveAccept={{yes: t("Accept"), no: t("Close")}}
                onAccept={() => {
                  closeNhsResultsWarning();
                  setActiveStep(0);
                  props.setSearchValue(admit?.nhsNumber);
                  props.searchPatients(admit?.nhsNumber);
                }}
                message={t(`There are active records for NHS Number <b>${admit?.nhsNumber}</b>. Please use patient search and select the patient from the list.`)}
            />

          <Dialog
            open={isDialogOpen}
            // onClose={closeDialog}
            disableEscapeKeyDown
            sx={{ backdropFilter: "blur(5px)" }}
          >
            <UnknownPatientBanner
              genderOptions={genderOptions}
              setActiveStep={setActiveStep}
              setAdmitToUnknown={setAdmitToUnknown}
              onClose={closeDialog}
              addAdmit={addAdmit}
              admit={admit}
              setAdmit={setAdmit}
              admission={admission}
              setAdmission={setAdmission}
              fastReg={fastReg}
              speedRegFlag={speedRegFlag}
              arrivalModeOptions={props.arrivalModeOptions}
              isArrivalModeOptionsLoading={props.isArrivalModeOptionsLoading}
              chiefComplaintOptions={props.chiefComplaintOptions}
              isChiefComplaintOptionsLoading={props.isArrivalModeOptionsLoading}
              conveyingAmbulanceOptions={conveyingAmbulanceOptions}
              conveyingAmbulanceLoading={conveyingAmbulanceLoading}
            />
          </Dialog>
        </Grid>
      </div>
    </Paper>
  );
};

export default DemographicDetails;
